/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    "use strict";

    export class MeevoKeypad {
        restrict = "E";
        scope = {
            name: "@",
            selectedAmount: "=ngModel",
            addKey: "@",
            addPayment: "&",
            useBalance: "&",
            ngChange: "&ngChange",
            minValue: "=?",
            inputInvalidMessage: "@?",
        };
        transclude = true;
        focused = false;

        templateUrl = "app/components/controls/keypadTemplate.html";

        link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) => {
            scope.decimalMask = this.identityService.current().decimalPositions || 2;
            const internalDecimalSeparator = '.';

            scope.isInputInvalid = false;
            if (angular.isUndefined(scope.minValue)) {
                scope.minValue = 0;
            }

            scope.elementHeight = null;

            function setElementHeight() {
                scope.elementHeight = angular.element('.cash-calculator').css('height');
            }

            this.$timeout(() => {
                setElementHeight();
            }, 100)

            angular.element(window).bind('orientationchange', () => {
                this.$timeout(() => {
                    setElementHeight();
                }, 1000);
            });

            angular.element(window).on('resize', () => {
                setElementHeight();
            });

            scope.inputNumber = (value) => {
                scope.$on('focus',() => {
                    scope.selectedAmount = parseFloat('' + scope.selectedAmount);
                    this.focused = true;
                })

                if(!this.focused) {
                    scope.selectedAmount = scope.selectedAmount.toString();
                }

                if (typeof scope.selectedAmount == 'number' ) {
                    scope.selectedAmount = 0;
                }
                const decimalIndex = scope.selectedAmount.toString().indexOf(".");
                const decimalLength = scope.decimalMask + 1;

                if ((value == internalDecimalSeparator && decimalIndex != -1) || (decimalIndex == scope.selectedAmount.length - decimalLength && decimalIndex > -1)) {
                    return;
                }

                scope.selectedAmount = (scope.selectedAmount == '0' ? '' : scope.selectedAmount) + value.toString();

                if (scope.selectedAmount == internalDecimalSeparator) {
                    scope.selectedAmount = '0' + internalDecimalSeparator;
                }
                if (value != internalDecimalSeparator) {
                    scope.viewAmount = parseFloat(scope.selectedAmount) || 0;
                }

                scope.isInputInvalid = scope.viewAmount < +scope.minValue;

                if (_.isFunction(scope.ngChange)) {
                    this.$timeout(() => {
                        scope.ngChange();
                    });
                }
                this.focused = false;
            }

            scope.delete = () => {
                scope.selectedAmount = scope.selectedAmount.toString();
                if (scope.selectedAmount[scope.selectedAmount.length - 1] == internalDecimalSeparator) {
                    scope.selectedAmount = scope.selectedAmount.slice(0, -2);
                } else {
                    scope.selectedAmount = scope.selectedAmount.slice(0, -1);
                }
                scope.viewAmount = parseFloat(scope.selectedAmount) || 0;

                scope.isInputInvalid = scope.viewAmount < +scope.minValue;

                if (_.isFunction(scope.ngChange)) {
                    this.$timeout(() => {
                        scope.ngChange();
                    });
                }
            }

            scope.clear = () => {
                scope.selectedAmount = 0;
            }

            scope.handleNullValue = () => {
                if (Model.Guard.isNothing(scope.selectedAmount, false)) {
                   scope.currentValue = 0;
                }
            }

            scope.handleNullValue();

            scope.formatCurrValue = () => {
                let meevoCurrency = this.$filter('meevoCurrency') as any;
                if (Model.Guard.isSomething(scope.selectedAmount) || !scope.selectedAmount) {
                    scope.selectedAmount = meevoCurrency(scope.selectedAmount, null, null, scope.decimalMask);
                }
            };

            scope.valueChanged = () => {
                if (scope.selectedAmount == internalDecimalSeparator) {
                    scope.selectedAmount = '0' + internalDecimalSeparator;
                }

                let viewAmount = parseFloat(scope.selectedAmount) || 0;
                scope.isInputInvalid = viewAmount < +scope.minValue;

                if (_.isFunction(scope.ngChange)) {
                    this.$timeout(() => {
                        scope.ngChange();
                    });
                }
            }
        }

        constructor(
            private $filter: ng.IFilterService,
            private $timeout: ng.ITimeoutService,
            private identityService: Meevo.Components.Common.IIdentityService
        ) {
        }

        static factory(): angular.IDirectiveFactory {
            let directive = (
                $filter: ng.IFilterService,
                $timeout: ng.ITimeoutService,
                identityService: Meevo.Components.Common.IIdentityService
            ) => new MeevoKeypad(
                $filter,
                $timeout,
                identityService
            );

            directive.$inject = [
                "$filter",
                "$timeout",
                "meevo.components.common.IdentityService"
            ];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoKeypad", MeevoKeypad.factory());
}